import {FundingTypes} from "./FinalReportFundingTypes";
import {OmitModes} from "./OmitModes";
import {Numbers} from "../../../../utils/Numbers";

export const FinalReportCostExported = {

	generate (reportComponent) {
		return {
			administrativeCosts: this.getExportAdministrativeCosts(reportComponent),
			administrativeSummary: this.getSummaryCosts(reportComponent, OmitModes.omitActions),
			actionCosts: this.getExportActionCosts(reportComponent),
			actionSummary: this.getSummaryCosts(reportComponent, OmitModes.omitAdministrative),
			wholeSummary: this.getSummaryCosts(reportComponent),
			financeSources: this.getFinanceSources(reportComponent)
		};
	},

	getExportAdministrativeCosts (ref) {
		let costs = [];
		for (let cost of ref.administrativeMerged.costs) {
			costs.push(this.createCostItem(cost, ref));
		}
		return costs;
	},

	getSummaryCosts (ref, omitMode) {
		return {
			projectSum: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.ALL], omitMode),
			donationFromProject: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.DOTATION], omitMode),
			otherFromProject: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.OTHER, FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE], omitMode),
			ownHumanFromProject: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION], omitMode),
			ownInKindFromProject: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND], omitMode),
			documentSum: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.ALL], omitMode),
			donationFromDocument: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.DOTATION], omitMode),
			otherFromDocument: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.OTHER, FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE], omitMode),
			ownHumanFromDocument: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION], omitMode),
			ownInKindFromDocument: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND], omitMode),
			interestsFromDocument: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.INCOME, FundingTypes.INTEREST], omitMode)
		};
	},

	getExportActionCosts (ref) {
		let costs = [];
		for (let action of ref.costsMerged) {
			let item = {};
			item.serialNumber = action.serialNumber;
			item.name = action.action;
			let currentActionCosts = [];
			for (let cost of action.costs) {
				currentActionCosts.push(this.createCostItem(cost, ref));
			}
			item.costs = currentActionCosts;
			item.actionCostSummary = {
				projectSum: Numbers.methods.formatCurrency(action.fromProjectSumTotal),
				donationFromProject: Numbers.methods.formatCurrency(ref.sumOfCostsFromTypesFromSingleAction(action, ref.fromDotationFromProject)),
				otherFromProject: Numbers.methods.formatCurrency(ref.sumOfCostsFromTypesFromSingleAction(action, ref.fromOtherFromProject)),
				ownHumanFromProject: Numbers.methods.formatCurrency(ref.sumOfCostsFromTypesFromSingleAction(action, ref.fromOwnHumanFromProject)),
				ownInKindFromProject: Numbers.methods.formatCurrency(ref.sumOfCostsFromTypesFromSingleAction(action, ref.fromOwnInKindFromProject)),
				documentSum: Numbers.methods.formatCurrency(action.fromDocumentSumTotal),
				donationFromDocument: Numbers.methods.formatCurrency(ref.sumOfCostsFromTypesFromSingleAction(action, ref.fromDotationFromDocument)),
				otherFromDocument: Numbers.methods.formatCurrency(ref.sumOfCostsFromTypesFromSingleAction(action, ref.fromOtherFromDocument)),
				ownHumanFromDocument: Numbers.methods.formatCurrency(ref.sumOfCostsFromTypesFromSingleAction(action, ref.fromOwnHumanFromDocument)),
				ownInKindFromDocument: Numbers.methods.formatCurrency(ref.sumOfCostsFromTypesFromSingleAction(action, ref.fromOwnInKindFromDocument)),
				interestsFromDocument: Numbers.methods.formatCurrency(ref.sumOfCostsFromTypesFromSingleAction(action, ref.fromInterestsFromDocument))
			};
			costs.push(item);
		}
		return costs;
	},

	createCostItem (cost, ref) {
		return {
			serialNumber: cost.serialNumber,
			name: cost.name,
			projectSum: Numbers.methods.formatCurrency(cost.fromProjectSum),
			donationFromProject: Numbers.methods.formatCurrency(ref.fromDotationFromProject(cost)),
			otherFromProject: Numbers.methods.formatCurrency(ref.fromOtherFromProject(cost)),
			ownHumanFromProject: Numbers.methods.formatCurrency(ref.fromOwnHumanFromProject(cost)),
			ownInKindFromProject: Numbers.methods.formatCurrency(ref.fromOwnInKindFromProject(cost)),
			documentSum: Numbers.methods.formatCurrency(cost.fromDocumentSum),
			donationFromDocument: Numbers.methods.formatCurrency(ref.fromDotationFromDocument(cost)),
			otherFromDocument: Numbers.methods.formatCurrency(ref.fromOtherFromDocument(cost)),
			ownHumanFromDocument: Numbers.methods.formatCurrency(ref.fromOwnHumanFromDocument(cost)),
			ownInKindFromDocument: Numbers.methods.formatCurrency(ref.fromOwnInKindFromDocument(cost)),
			interestsFromDocument: Numbers.methods.formatCurrency(ref.fromInterestsFromDocument(cost))
		};
	},

	getFinanceSources (ref) {
		let sources = [];
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.DOTATION, FundingTypes.INTEREST, FundingTypes.INCOME]),
			projectCosts: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.DOTATION, FundingTypes.INTEREST, FundingTypes.INCOME])
		});
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.DOTATION]),
			projectCosts: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.DOTATION])
		});
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.INTEREST]),
			projectCosts: "-"
		});
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.INCOME]),
			projectCosts: "-"
		});
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER]),
			projectCosts: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER])
		});
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION]),
			projectCosts: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION])
		});
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.MONEY_FROM_RECIPIENTS]),
			projectCosts: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.MONEY_FROM_RECIPIENTS])
		});
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.OTHER_PUBLIC_SOURCE]),
			projectCosts: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.OTHER_PUBLIC_SOURCE])
		});
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.OTHER]),
			projectCosts: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.OTHER])
		});
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND]),
			projectCosts: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND])
		});
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_HUMAN_CONTRIBUTION]),
			projectCosts: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_HUMAN_CONTRIBUTION])
		});
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND]),
			projectCosts: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND])
		});
		sources.push({
			documentCosts: ref.formattedSumOfCostsFromTypesFromDocument([FundingTypes.ALL]),
			projectCosts: ref.formattedSumOfCostsFromTypesFromProject([FundingTypes.ALL])
		});
		sources.push({
			documentCosts: ref.percentSumOfCostsToDotationFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER, FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND]) + " %",
			projectCosts: ref.percentSumOfCostsToDotationFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER, FundingTypes.OWN_HUMAN_CONTRIBUTION, FundingTypes.OWN_CONTRIBUTION_IN_KIND]) + " %"
		});
		sources.push({
			documentCosts: ref.percentDotationFromDocumentFormatted() + " %",
			projectCosts: ref.percentDotationFromProjectFormatted() + " %"
		});
		sources.push({
			documentCosts: ref.percentSumOfCostsToDotationFromDocument([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER]) + " %",
			projectCosts: ref.percentSumOfCostsToDotationFromProject([FundingTypes.OWN_FINANCIAL_CONTRIBUTION, FundingTypes.MONEY_FROM_RECIPIENTS, FundingTypes.OTHER_PUBLIC_SOURCE, FundingTypes.OTHER]) + " %"
		});
		sources.push({
			documentCosts: ref.percentSumOfCostsToDotationFromDocument([FundingTypes.OWN_CONTRIBUTION_IN_KIND, FundingTypes.OWN_HUMAN_CONTRIBUTION]) + " %",
			projectCosts: ref.percentSumOfCostsToDotationFromProject([FundingTypes.OWN_CONTRIBUTION_IN_KIND, FundingTypes.OWN_HUMAN_CONTRIBUTION]) + " %"
		});
		return sources;
	}
};